import { useEditorialText } from "../lib/EditorialText";
const BRAND = "S H & SONS ®";

export default function BrandText({ text }) {
  text = useEditorialText(text);
  return String(text ?? "").split(/(S H & SONS ®)/g).map((part, index) => (
    part === BRAND ? <span key={index} className="brand-name">{part}</span> : part
  ));
}
